import { useIsFetching } from '@tanstack/react-query';

import {
  Badge,
  Breadcrumbs,
  SkeletonBase,
} from '@unified-checkout/design-system';

import { IHeader } from '@app/dashboard/types/innerLayout/profile_details/header';

import styles from './Header.module.scss';

const Header = ({ title, subTitle, breadCrumbs, badge }: IHeader) => {
  const isFetching = useIsFetching();

  return (
    <div className={styles['header']}>
      <Breadcrumbs linksProps={breadCrumbs} />

      <div className={styles['header__content']}>
        <div className={styles['header__content-title']}>
          <p className={styles['header__content-title-text']}> {title} </p>
          {badge && !!isFetching ? (
            <SkeletonBase width="11rem" height="2rem" />
          ) : (
            <Badge {...badge} />
          )}
        </div>
        {!!subTitle && (
          <div className={styles['header__content-subtitle']}>{subTitle}</div>
        )}
      </div>
    </div>
  );
};

export default Header;
